export default __webpack_public_path__ + "static/media/checkMarkBlack.2f1ea183.svg";